/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-2016 Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */

import { GraphQLList as List } from 'graphql';
import fetch from '../../core/fetch';
import RealisationType from '../types/RealisationType';

const url = 'http://agenceprolifik.ca/dev/wp-json/wp/v2/realisations?filter[orderby]=menu_order&order=asc';

let items = [];

const realisations = {
    type: new List(RealisationType),
    resolve() {
        
        return fetch(url)
        .then(res => {
            
            return res.json();
           
        })
        .then(data => {
           
            items = data;
            return items;

        });
    },
};

export default realisations;



// WEBPACK FOOTER //
// ./data/queries/realisations.js